export default {"src":"/_next/static/media/pair-3.3ec385fe.svg","height":419,"width":497,"blurWidth":0,"blurHeight":0};